import createVueApp from '@/common/createApp'

Styxie.Initializers.GmbMultiLocationPosts = {
  index: async(props) => {
    const { default: MultiLocationPostsIndex } = await import('@/vue_widgets/gmb/multi_location_posts/index.vue')
    createVueApp(MultiLocationPostsIndex, { props })
  },
  show: async(props) => {
    const { default: MultiLocationPostsShow } = await import('@/vue_widgets/gmb/multi_location_posts/show.vue')
    createVueApp(MultiLocationPostsShow, { props })
  },
  new: async(props) => {
    const { default: MultiLocationPostsNew } = await import('@/vue_widgets/gmb/multi_location_posts/new.vue')
    createVueApp(MultiLocationPostsNew, { props })
  }
}
